import axios, {AxiosError, AxiosResponse} from "axios";
import { UserToken } from '../../interface/Server';
// ADS-006
// "Login
//
// Login ADS
//
// Endpoint:
//     /ads/user/login
//
// Method:
//     POST
//
// Params:
// {
//     'userName': 'Chaplin',
//     'password': 'changeit'
// }
//
// Return:
// {
//     'firstName': 'Charlie',
//     'lastName': 'Chaplin',
//     'primaryEmail': 'cc@c4sheep.com',
//     'westKowloonENewsletter': 'Chaplin',
//     'preferredLanguage': 'Chaplin',
//     'customerInterest': 'Chaplin',
//     'primaryAddress1': 'West Kowloon Art Park 1',
//     'primaryAddress2': 'West Kowloon Art Park 2',
//     'primaryAddress3': 'West Kowloon Art Park 3',
//     'mobile': '852-98765432',
//     'tcRead': true,
//     'picsRead': true,
//     'fundraisingInterest': true,
//     'donorNameInReceipt': 'Chaplin',
// }"


interface LoginInfo {
    username: string
    password: string,
    auth: any
}

interface LoginResponse {
    code: number,
    msg: string,
    data: UserToken,
}

export const loginADS = (loginInfo: LoginInfo): Promise<LoginResponse> =>
    axios.post(`/user/login/`, loginInfo).then(
        (res: AxiosResponse) => res.data as any
    ).catch((err: AxiosError) => console.log(err.message));
